import { tasksUpdatedBus } from '@/shared/api/rpc/events';
import { FileItem, Params } from '@/shared/api/rpc/types';

const KEY = 'RPC';
function bigintReplacer(_: string, value: unknown) {
  return typeof value === 'bigint' ? value.toString() : value;
}

export const rpcStorage = {
  get(): FileItem[] {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  },

  save(list: FileItem[]) {
    localStorage.setItem(KEY, JSON.stringify(list, bigintReplacer));
    tasksUpdatedBus.emit();
  },

  upsert(task: FileItem) {
    if (
      !task.app_hash_md5 ||
      ['FAILURE', 'try_term', 'ttl'].includes(task.state) ||
      ['refresh', 'commit', 'rollback'].includes(task.file_name)
    ) {
      return;
    }
    const list = this.get();
    const index = list.findIndex(
      (t: FileItem) => t.app_hash_md5 === task.app_hash_md5
    );
    index === -1 ? list.unshift(task) : (list[index] = task);
    this.save(list);
  },

  updateMeta(
    id: string,
    payload: {
      name?: string;
      params?: Params;
    }
  ) {
    const list = this.get();
    const index = list.findIndex((t: FileItem) => t.app_hash_md5 === id);
    if (index === -1) return;
    list[index] = {
      ...list[index],
      ...payload,
    };
    this.save(list);
  },

  remove(id: string) {
    this.save(this.get().filter((t: FileItem) => t.app_hash_md5 !== id));
  },

  clear() {
    localStorage.removeItem(KEY);
    tasksUpdatedBus.emit();
  },
};
